export default {
  getUras: state => state.uras,
  getUraSelecionada: state => state.uraSelecionada,
  getUraUse: state => state.uraUse,
  getRotasDisponiveis: state => state.rotasDisponiveis,
  getAudios: state => state.audios,
  getGruposDeRotas: state => state.gruposDeRotas,
}
